import React from "react";

export default function renderIcon({
  width = 24,
  height = 24,
  color = "#495057",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2617 16.2002H16.0571V14.7824H17.3238V14.1334H16.0571V13.3275H17.4123V12.6729H15.2617V16.2002Z"
        fill={color}
      />
      <path
        d="M18.6782 13.6416H17.8828V16.2016H18.6782V13.6416Z"
        fill={color}
      />
      <path
        d="M18.287 12.5322C18.0309 12.5322 17.8633 12.7045 17.8633 12.9299C17.8633 13.1501 18.0257 13.328 18.2766 13.328C18.5439 13.328 18.7058 13.15 18.7058 12.9299C18.7007 12.7046 18.5439 12.5322 18.287 12.5322Z"
        fill={color}
      />
      <path
        d="M11.5282 7.46945C11.5282 7.31225 11.42 7.23047 11.2398 7.23047C11.1455 7.23047 11.091 7.23589 11.0625 7.24288V7.71857H11.2165C11.4126 7.7192 11.5282 7.62107 11.5282 7.46945Z"
        fill={color}
      />
      <path
        d="M20.7272 9.44798H17.351C16.8448 6.95564 14.6415 5.08008 11.9998 5.08008C9.35808 5.08008 7.15539 6.95603 6.64938 9.44798H3.273C1.46822 9.44798 0 10.916 0 12.7208V15.6474C0 17.4521 1.46822 18.9206 3.273 18.9206H20.7272C22.532 18.9206 24 17.4521 24 15.6474V12.7208C23.9996 10.916 22.532 9.44798 20.7272 9.44798ZM6.06874 16.2007H5.20567L4.90746 14.6832C4.83919 14.3274 4.78152 13.9974 4.73989 13.5949H4.72967C4.66729 13.9922 4.60924 14.3273 4.52541 14.6832L4.18972 16.2007H3.31589L2.47851 12.6734H3.33184L3.59855 14.1231C3.67696 14.5468 3.75057 15.0023 3.80815 15.3582H3.81829C3.87595 14.9761 3.96017 14.5515 4.04871 14.1127L4.34692 12.6734H5.19467L5.47686 14.1598C5.55566 14.5735 5.61332 14.9505 5.66596 15.3426H5.67578C5.72842 14.9505 5.80658 14.5368 5.88004 14.1132L6.16765 12.6734H6.97887L6.06874 16.2007ZM8.02349 16.2007H7.22783V13.6412H8.02349V16.2007ZM7.62039 13.3279C7.36947 13.3279 7.20693 13.1496 7.20693 12.9295C7.20693 12.7045 7.37442 12.5321 7.63092 12.5321C7.88742 12.5321 8.04447 12.7044 8.04918 12.9295C8.04918 13.1505 7.88742 13.3279 7.62039 13.3279ZM13.5767 6.9499H14.6439V7.27145H13.9673V7.63212H14.6052V7.95045H13.9673V8.36219H14.6806V8.68413H13.5767V6.9499ZM12.2021 6.9499H13.2691V7.27145H12.593V7.63212H13.2309V7.95045H12.593V8.36219H13.3054V8.68413H12.2021V6.9499ZM10.3765 7.27145H9.7105V7.66756H10.3326V7.98714H9.7105V8.68405H9.31951V6.9499H10.3765L10.3765 7.27145ZM11.0615 8.68405H10.673V6.97284C10.7988 6.95226 10.9843 6.93694 11.1955 6.93694C11.4524 6.93694 11.6322 6.97567 11.756 7.0734C11.8613 7.15573 11.9181 7.27884 11.9181 7.43902C11.9181 7.65781 11.7608 7.80904 11.6114 7.86349V7.87103C11.7327 7.92013 11.7997 8.03302 11.843 8.19258C11.8972 8.39047 11.9487 8.61704 11.9822 8.68405H11.581C11.5553 8.6326 11.5112 8.49331 11.4626 8.28033C11.4135 8.06154 11.3389 8.00513 11.1775 8.00191H11.0614V8.68405H11.0615ZM22.6911 15.6474C22.6911 16.7296 21.8103 17.6113 20.7268 17.6113H12.9512C11.8274 16.8845 11.0819 15.6223 11.0819 14.1841C11.0819 12.746 11.8275 11.4844 12.9512 10.7573H20.7268C21.8094 10.7573 22.6911 11.6379 22.6911 12.7208V15.6474Z"
        fill={color}
      />
    </svg>
  );
}
